export enum ERoute28Product {
    DIGITAL = 'Digital',
    EQUITY_INDICES = 'Equity Indices',
    PRECIOUS_METALS = 'Precious Metals',
    FOREIGN_EXCHANGE = 'Foreign Exchange',
    FIXED_INCOME = 'Fixed Income',
}
